import React, { useImperativeHandle, forwardRef, useState, useEffect } from 'react';
import {
  Grid, TextField, Button, Box, Typography, FormControl, InputLabel, Select, MenuItem, FormHelperText
} from '@mui/material';

import { mockEstados } from '../mock';
import { serviceRecuperaCidades, serviceViaCep } from '../Service/service';
import { formatoMascaras, aplicaMascara, validarEmail } from '../util';
import limiteTamanhoCampos from '../limiteCampos';

const estados = mockEstados();

const FormularioEndereco = forwardRef((props, ref) => {
  const [formData, setFormData] = useState(props.formData);
  const [listaCidades, setListaCidades] = useState([]);
  const [cidadeTemp, setCidadeTemp] = useState(null);

  const [validacao, setValidacao] = useState(
    {
      endereco: false,
      // numero: false,
      complemento: false,
      bairro: false,
      cep: false,
      estado: false,
      cidade: false,
      email: false,
    });

  useEffect(() => {
    validaForm();
    props.onChildDataChange(formData);
  }, [formData]);

  useEffect(() => {
    validaForm();

    if (formData && formData.estado)
      atualizaCidades(formData.estado);
  }, []);

  const validaForm = () => {
    const propriedades = Object.keys(validacao);
    const novaValidacao = { ...validacao };

    propriedades.forEach(propriedade => {
      if (formData)
        novaValidacao[propriedade] = propriedade == 'email'
          ? validarEmail(formData[propriedade])
          : (formData[propriedade] !== "" && formData[propriedade] != undefined && formData[propriedade] != null);
    });

    setValidacao(novaValidacao);
  }

  const handleChange = (event) => {
    let { name, value } = event.target;

    value = limiteTamanhoCampos(name, value);

    if (name == 'cep')
      value = aplicaMascara(value.replace(/\D/g, ''), formatoMascaras().CEP)

    if (name == 'telefone' || name == 'celular')
      value = aplicaMascara(value.replace(/\D/g, ''), formatoMascaras().TEL)

    if (name == 'cep' && value.length >= 'xxxxx-xxx'.length)
      recuperaPorCep(value)

    setFormData((prevState) => {
      const updatedState = {
        ...prevState,
        [name]: value,
      };

      if (name === 'estado') {
        updatedState.cidade = '';
        atualizaCidades(value);
      }

      return updatedState;
    });
  };

  const recuperaPorCep = async (cep) => {
    serviceViaCep(cep, function (dadosEndereco) {

      setFormData((prevState) => {
        const updatedState = {
          ...prevState,
        };

        updatedState.endereco = dadosEndereco.logradouro;
        updatedState.bairro = dadosEndereco.bairro;
        updatedState.estado = dadosEndereco.uf;

        return updatedState;
      });

      setCidadeTemp(dadosEndereco.localidade.normalize('NFD').replace(/[\u0300-\u036f]/g, ''))
      atualizaCidades(dadosEndereco.uf);

      props.setIsLoading(true);
      setTimeout(() => {
        props.setEtapa(1);
      }, 500);
      setTimeout(() => {
        props.setEtapa(2);
        props.setIsLoading(false);
      }, 1000);

    });
  }

  useEffect(() => {
    if (cidadeTemp) {
      const cidadeDaLista = listaCidades.find(t => t.nome.toUpperCase() == cidadeTemp.toUpperCase());
      setFormData((prevState) => {
        const updatedState = {
          ...prevState,
        };
        updatedState.cidade = cidadeDaLista?.nome;
        return updatedState;
      });
      setCidadeTemp(null);      
    }
  }, [listaCidades]);

  const atualizaCidades = async (estado) => {
    try {
      const cidades = await serviceRecuperaCidades(estado);
      if (cidades)
        setListaCidades(cidades.map(t => { return { id: t.nuSeqRegWebCd, nome: t.nmCidade } }));
    } catch (error) {

    }
  }

  useImperativeHandle(ref, () => ({
    validarFormulario() {
      if (Object.values(validacao).some(value => !value)) {
        return false;
      }
      return true;
    },
    getDados() {
      return formData;
    }
  }));

  // const cssQuebraPagina = { 'page-break-after': 'auto', 'break-after': 'page', 'width': '100%' };

  return (
    <>
      {/* <div style={cssQuebraPagina}></div> */}
      <Box sx={{ flexGrow: 1, p: 2 }}>
        <Typography variant="h4" gutterBottom>
          Endereço
        </Typography>
        <form>
          <Grid container spacing={2} sx={{ display: 'flex', flexWrap: 'wrap' }}>

            {/* Linha do CEP */}
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                fullWidth
                label="CEP"
                variant="outlined"
                margin="normal"
                name="cep"
                value={formData?.cep}
                onChange={handleChange}
                required
                inputProps={{ pattern: '[0-9]{5}-[0-9]{3}' }}
                helperText="Formato: 00000-000"
                error={!validacao.cep}
              />
            </Grid>

          </Grid>
          <Grid container spacing={2} sx={{ display: 'flex', flexWrap: 'wrap' }}>

            {/* Linha do Endereço, Número e Complemento */}
            <Grid item xs={12} sm={7} md={7}>
              <TextField
                fullWidth
                label="Endereço"
                variant="outlined"
                margin="normal"
                name="endereco"
                value={formData?.endereco}
                onChange={handleChange}
                required
                error={!validacao.endereco}
              />
            </Grid>
            <Grid item xs={12} sm={5} md={5}>
              <TextField
                fullWidth
                label="Número"
                variant="outlined"
                margin="normal"
                name="numero"
                type="number"
                value={formData?.numero}
                onChange={handleChange}                                
              />
            </Grid>
            <Grid item xs={12} sm={5} md={5}>
              <TextField
                fullWidth
                label="Complemento"
                variant="outlined"
                margin="normal"
                name="complemento"
                value={formData?.complemento}
                onChange={handleChange}
                error={!validacao.complemento}
              />
            </Grid>

            <Grid item xs={12} sm={7} md={7}>
              <TextField
                fullWidth
                label="Bairro"
                variant="outlined"
                margin="normal"
                name="bairro"
                value={formData?.bairro}
                onChange={handleChange}
                required
                error={!validacao.bairro}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth variant="outlined" margin="normal" required
                error={!validacao.estado}>
                <InputLabel>Estado</InputLabel>
                <Select
                  name="estado"
                  value={formData?.estado}
                  onChange={handleChange}
                  label="Estado"
                >
                  {estados.map((estado) => (
                    <MenuItem key={estado.id} value={estado.id}>
                      {estado.nome}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth variant="outlined" margin="normal"
                required
                error={!validacao.cidade}>
                <InputLabel>Cidade</InputLabel>
                <Select
                  name="cidade"
                  value={formData?.cidade}
                  onChange={handleChange}
                  label="Cidade"
                >
                  {listaCidades.map((cidade) => (
                    <MenuItem key={cidade.id} value={cidade.nome}>
                      {cidade.nome}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Linha do Telefone, Celular e Email */}
            <Grid item xs={12} sm={3} md={3}>
              <TextField
                fullWidth
                label="Telefone"
                variant="outlined"
                margin="normal"
                name="telefone"
                value={formData?.telefone}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <TextField
                fullWidth
                label="Celular"
                variant="outlined"
                margin="normal"
                name="celular"
                value={formData?.celular}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                fullWidth
                label="E-mail"
                variant="outlined"
                margin="normal"
                name="email"
                value={formData?.email}
                onChange={handleChange}
                required
                type="email"
                helperText="Formato: exemplo@dominio.com"
                error={!validacao.email}
              />
            </Grid>


          </Grid>
        </form>
      </Box>
    </>
  );
});

export default FormularioEndereco;
